module.exports = __webpack_public_path__ + "img/boxed-4.1c2f017a.jpg";